import React from 'react';
import { connect } from 'react-redux';


import { Table, Column, DatePicker, PageBar } from '@tencent/spaui';

import { RPCFactory } from '../../../utils/RequestUtil';
import { withRouter } from 'react-router';

import { isInPushUrlWhiteList } from '../../../utils/whiteList';

const mapStateToProps = (state) => ({ ...state.leadsManage });
const pageSizeList = [5, 10, 20];

class LeadsApiDataPage extends React.Component {
  componentDidMount() {
    const startActionDate = this.dateFormat(new Date(new Date().getTime() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd');
    const endActionDate = this.dateFormat(new Date(), 'yyyy-MM-dd');
    // 获取API的配置
    RPCFactory.leadsApiData
      .getReport_leads(window.pageProps.uid, startActionDate, endActionDate)
      .done((data) => {
        this.setState({
          pushLeadsNum: data.pushLeadsNum, // 转发线索总条数
          highIntentionCumstomersNum: data.highIntentionCumstomersNum, // 高意向客户数
          ineffectiveLeadsNum: data.ineffectiveLeadsNum, // 无效线索条数
          potentialCustomersNum: data.potentialCustomersNum, // 潜在客户数
          reportLeadsNum: data.reportLeadsNum, // 上报线索总条数
        });
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  }

  dateFormat(Date, fmt) {
    const o = {
      'M+': Date.getMonth() + 1, // 月份
      'd+': Date.getDate(), // 日
      'H+': Date.getHours(), // 小时
      'm+': Date.getMinutes(), // 分
      's+': Date.getSeconds(), // 秒
      'q+': Math.floor((Date.getMonth() + 3) / 3), // 季度
      S: Date.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, `${Date.getFullYear()}`.substr(4 - RegExp.$1.length));
    for (const k in o)
      if (new RegExp(`(${k})`).test(fmt))
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length));
    return fmt;
  }

  constructor(props) {
    super(props);

    this.state = {
      pushLeadsNum: '',
      highIntentionCumstomersNum: '',
      ineffectiveLeadsNum: '',
      potentialCustomersNum: '',
      reportLeadsNum: '',
      entities: [],
    };
    this.pageIndex = 1;
    this.pageSize = 10;
    this.totalSize = 0;
    this.startActionDate = this.dateFormat(new Date(new Date().getTime() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd');
    this.endActionDate = this.dateFormat(new Date(), 'yyyy-MM-dd');
    this.handleDateChange = this.handleDateChange.bind(this);
    this.getReportList();
  }

  handleDateChange(event, startActionDate, endActionDate) {
    this.startActionDate = startActionDate;
    this.endActionDate = endActionDate;
    this.getReportList();
  }

  /**
   * 页码点击
   * @param event
   * @param value
   */
  onChangePageIndex = (event, value) => {
    this.pageIndex = value;
    this.getReportList();
  };

  /**
   * 页面条目数量点击
   * @param event
   * @param value
   */
  onChangePageSize = (event, value) => {
    this.pageSize = value;
    this.pageIndex = 1;
    this.getReportList();
  };

  getReportList() {
    RPCFactory.leadsApiData
      .getReport_list(window.pageProps.uid, this.startActionDate, this.endActionDate, this.pageIndex, this.pageSize)
      .done((data) => {
        this.setState({
          entities: data.entities, // 转发线索总条数
        });
        this.totalSize = data.size;
      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
      });
  }

  goLeadsApiManage() {
    if (isInPushUrlWhiteList()) {
      window.location.hash = '#/system/leadsForward/Api';
    } else {
      // 这个地址的路由被注释掉了，原因不明
      this.props.history.push('/leadsApiManage');
    }
  }

  downloadReport() {
    window.open(
      `/api/v1/userapp/download_report_list?accountId=${window.pageProps.uid}&startActionDate=${this.startActionDate}&endActionDate=${this.endActionDate}`,
      '_blank',
    );
  }

  /**
   * 外呼部分end
   * =====================================================================
   */

  render() {
    const { date } = this.state;

    return (
      <div className="main">
        <div className="page-api-clue">
          <div className="sec-breadcrumb">
            <div className="breadcrumb">
              <a onClick={this.goLeadsApiManage.bind(this)} className="breadcrumb-back" role="button">
                <i className="icon icon-breadcrumb-back"></i>
              </a>
              <ol role="navigation" aria-label="breadcrumbs" className="breadcrumbs">
                <li>
                  <span>API回传线索统计</span>
                </li>
              </ol>
            </div>
          </div>
          <div className="card">
            <div className="callout">
              <div className="callout-title">什么是API回传？</div>
              <div className="callout-content">
                <ul className="callout-list">
                  <li>API回传线索的有效和无效信息，可应用于投放优化；</li>
                  <li>同时，平台可结合潜客优选能力，帮助您对新线索进行预评分，提升客服人员线索处理效率和成单率</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="page-api-clue-container">
              <div className="form-panel">
                <div className="toolbars">
                  <div className="toolbar table-toolbar">
                    <div className="toolbar-left">
                      <h4>
                        <span className="">近7日数据</span>
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="item-group">
                  <div className="fe-flex recent-data-box">
                    <div className="fe-flexBox recent-data">
                      <p className="data-title">转发数据总条数</p>
                      <p className="data-detail">{this.state.pushLeadsNum}</p>
                    </div>
                    <div className="fe-flexBox recent-data">
                      <p className="data-title">回传数据总条数</p>
                      <p className="data-detail">{this.state.reportLeadsNum}</p>
                    </div>
                    <div className="fe-flexBox recent-data">
                      <p className="data-title">无效线索条数</p>
                      <p className="data-detail">{this.state.ineffectiveLeadsNum}</p>
                    </div>
                    <div className="fe-flexBox recent-data">
                      <p className="data-title">潜在客户条数</p>
                      <p className="data-detail">{this.state.potentialCustomersNum}</p>
                    </div>
                    <div className="fe-flexBox recent-data">
                      <p className="data-title">高意向客户条数</p>
                      <p className="data-detail">{this.state.highIntentionCumstomersNum}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-panel">
                <div className="toolbars">
                  <div className="toolbar table-toolbar">
                    <div className="toolbar-left">
                      <h4>
                        <span className="">回传线索统计</span>
                      </h4>
                    </div>
                    <div className="toolbar-right">
                      <div className="toolbar-right-inner">
                        <div className="toolbar-right-group">
                          <div className="spaui-datepicker date-range">
                            <div className="spaui-datepicker-valueholder">
                              <DatePicker
                                horizontalPosition="left"
                                type="range"
                                startDate={this.startActionDate}
                                endDate={this.endActionDate}
                                onChange={this.handleDateChange}
                              />
                            </div>
                          </div>
                          <button
                            onClick={this.downloadReport.bind(this)}
                            className="borderless spaui-button spaui-button-default"
                            data-spaui="1042"
                            type="button"
                          >
                            <i className="icon icon-download"></i>
                            <span className="spaui-text">下载数据</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="datalist">
                  <Table data={this.state.entities}>
                    <Column name="leadsId">线索ID</Column>t <Column name="campaignId">推广计划</Column>
                    <Column name="adId">广告</Column>
                    <Column name="leadsConvertType">转化状态</Column>
                    <Column name="leadsIneffectReason">无效原因</Column>
                    <Column name="lastPushTime">线索提交时间</Column>
                    <Column name="lastModifiedTime">线索回传时间</Column>
                  </Table>
                  <PageBar
                    value={this.pageIndex}
                    pageSize={this.pageSize}
                    totalSize={this.totalSize}
                    pageSizeList={pageSizeList}
                    onChange={this.onChangePageIndex}
                    onPageSizeChange={this.onChangePageSize}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const leadsApiDataPage = withRouter(connect(mapStateToProps)(LeadsApiDataPage));
export default leadsApiDataPage;
